__turbopack_context__.v({
  "header": "PopularCitiesContainer-module-scss-module__2eeofa__header",
  "root": "PopularCitiesContainer-module-scss-module__2eeofa__root",
});
